import type { RuntimeConfig } from 'nuxt/schema'
import { DefaultRegion, RegionEnum } from '~/enums/Region'
import { H3Event } from 'h3'

export const getRegion = (host: string, config: RuntimeConfig) => {
  switch (host) {
    case config.public.locale.lv.appUrl: {
      return RegionEnum.LV
    }
    case config.public.locale.ee.appUrl: {
      return RegionEnum.EE
    }
    case config.public.locale.lt.appUrl: {
      return RegionEnum.LT
    }
    case config.public.locale.pj.appUrl: {
      return RegionEnum.PERKUJAV
    }
    case config.public.locale.tp.appUrl: {
      return RegionEnum.TARPININKE
    }
    case config.public.locale.wl.appUrl: {
      return RegionEnum.WHITELABEL
    }
    case config.public.locale.nl.appUrl: {
      return RegionEnum.NORIULIVE
    }
    case config.public.locale.ae.appUrl: {
      return RegionEnum.AMEERIKAEESTIS
    }
    case config.public.locale.default.appUrl:
    default: {
      return DefaultRegion
    }
  }
}

export default (event?: H3Event, runtimeConfig?: RuntimeConfig, url?: URL) => {
  const config = runtimeConfig ?? useRuntimeConfig()
  const host = event
    ? getRequestHost(event, {
        xForwardedHost: true,
      })
    : url?.host ?? useRequestURL().host
  const region = getRegion(host, config)
  const { defaultLanguageIso, defaultCountryId, appUrl } = config.public.locale[region]

  return {
    iso: defaultLanguageIso.toLowerCase(),
    id: defaultCountryId,
    appUrl: `https://${appUrl}`,
    region,
  }
}
